// eslint-disable-next-line no-undef
const { __, sprintf } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

// Échappe une valeur destinée à un attribut HTML (un titre produit peut contenir
// une apostrophe ou un guillemet et casser l'attribut).
const escapeAttr = (value) =>
  String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

// Prix le plus bas (pro ou public selon l'utilisateur), préfixé de « À partir de »
// quand le produit variable a plusieurs prix. Fallback sur l'ancienne fourchette
// pour les enregistrements Algolia pas encore réindexés.
const feedPriceHtml = (item) => {
  const isPro = object.isPro
  const minHtml = isPro
    ? item.minProPriceHtml || item.minPriceHtml
    : item.minPriceHtml
  const hasRange = isPro ? item.hasProPriceRange : item.hasPriceRange

  if (!minHtml) {
    return (isPro ? item.proPriceHtml : item.priceHtml) || ''
  }

  return hasRange
    ? `<span class="vn-price__from">${__('From', 'vn')}</span> ${minHtml}`
    : minHtml
}

const productHit = (item, classes = '') => {
  const mainImage = (item.images && item.images.full) || ''
  const hoverImage = (item.images && item.images.hover) || mainImage
  // product_type est une taxonomie : seul un produit variable propose la personnalisation
  // (même règle que feed-product.php / feed-product-hit.php).
  const isVariable = item?.product_type?.[0]?.name === 'variable'

  return `
    <article class="feed-product ${classes}">
        <a href="${item.url}" class="feed-product__wrapper ${item.images && item.images.hover_image_full ? 'is-full' : ''}">
            <div class="feed-product__medias">
                <img class="feed-product__image feed-product__image--main" src="${escapeAttr(mainImage)}" alt="${escapeAttr(item.title)}" loading="lazy" decoding="async">
                <img class="feed-product__image feed-product__image--hover" src="${escapeAttr(hoverImage)}" alt="" aria-hidden="true" loading="lazy" decoding="async">
            </div>
            <div class="feed-product__top-part">
                <div class="feed-product__suptitle">
                    ${item.productSupTitle}
                </div>
                <div class="feed-product__tags">
                    ${
      item?.product_tag?.length
          ? item.product_tag.map((tag) => {
              return `<span class="feed-product__tag">${tag.name}</span>`
          })
          : ''
  }
                </div>
            </div>
            <div class="feed-product__bottom-part">
                <div class="feed-product__title">
                    ${item.title}
                </div>
                <div class="feed-product__price vn-price">
                    ${feedPriceHtml(item)}
                </div>
            </div>
            <div class="feed-product__action-part d-none-mob grid">
                <button data-href="?add-to-cart=${item.default_variation_id ? item.default_variation_id : item.objectID}" class="vn-btn vn-btn--primary action-part__add ${isVariable ? 'g-col-6' : 'g-col-12'}">
                    <span class="vn-a-content">${__('Add to cart', 'vn')}</span>
                </button>
                <button data-href="${item.url}" class="vn-btn vn-btn--primary action-part__choose g-col-6 ${isVariable ? '' : 'hidden'}">
                    <span class="vn-a-content">${__('Custom your glasses', 'vn')}</span>
                </button>
            </div>
        </a>
    </article>
  `
}

const partnerShopHit = (item, classes = '') => {
  return `
    <div class="${classes}">
        <article class="feed-partner-shop">
            ${item.status == 'publish' ?
                '<a href="' + item.url +'" class="feed-partner-shop__wrapper">' :
                '<div class="feed-partner-shop__wrapper">'
            }
                <div class="feed-partner-shop__image">
                    <img src="${item.images.full ? item.images.full : '' }" alt="">
                </div>
                <div class="feed-partner-shop__texts">
                    <div class="feed-partner-shop__texts-container">
                        <div class="feed-partner-shop__title">
                            ${item.title}
                        </div>
                        <div class="feed-partner-shop__address">
                            <i class="vn-icons-location"></i>
                            ${item.shopAddress}
                        </div>
                    </div>
                    ${item.status == 'publish' ? '<div class="vn-btn vn-btn--white">' + __('Discover the shop', 'vn') + '</div>' : ''}
                </div>
            ${item.status == 'publish' ?
                  '</a>' :
                  '</div>'
            }
        </article>
    </div>
  `
}

const noResult = `<div class="feed-none g-col-6">${__(
  'There were no results!',
  'vn'
)}</div>`

const productsButton = {}
productsButton.textContent = __('Load more products', 'vn')
productsButton.buttonContent = __('See more products', 'vn')

// Numéros de page à afficher : première, dernière, courante ±1, null pour une ellipse.
// Même algorithme que vn_get_shop_pagination_pages() (inc/Algolia/shop-pagination.php).
const getPaginationPages = (current, total) => {
  const pages = [...new Set([1, current - 1, current, current + 1, total])]
    .filter((page) => page >= 1 && page <= total)
    .sort((a, b) => a - b)

  const items = []
  let previous = 0

  pages.forEach((page) => {
    if (page - previous === 2) {
      items.push(page - 1)
    } else if (page - previous > 2) {
      items.push(null)
    }

    items.push(page)
    previous = page
  })

  return items
}

// Pagination de la boutique. Réplique le markup de vn_get_shop_pagination_html()
// (inc/Algolia/shop-pagination.php), servi dans le HTML initial : toute modification
// ici doit être reportée là-bas. current est en base 1, createURL(page) en base 1.
const shopPagination = (current, total, createURL) => {
  if (total <= 1) {
    return ''
  }

  const link = (page, content, atts = '') =>
    `<a class="pt-custom-shop__pagination-link" href="${escapeAttr(createURL(page))}" data-page="${page}"${atts}>${content}</a>`

  const arrow = '<i class="vn-icons-arrow_forward" aria-hidden="true"></i>'

  const items = getPaginationPages(current, total).map((page) => {
    if (page === null) {
      return '<li class="pt-custom-shop__pagination-item pt-custom-shop__pagination-item--ellipsis" aria-hidden="true">…</li>'
    }

    const label = escapeAttr(sprintf(__('Page %s', 'vn'), page))
    const ariaCurrent = page === current ? ' aria-current="page"' : ''

    return `<li class="pt-custom-shop__pagination-item">${link(page, page, ` aria-label="${label}"${ariaCurrent}`)}</li>`
  })

  if (current > 1) {
    items.unshift(`<li class="pt-custom-shop__pagination-item pt-custom-shop__pagination-item--prev">${link(current - 1, arrow, ` rel="prev" aria-label="${escapeAttr(__('Previous page', 'vn'))}"`)}</li>`)
  }

  if (current < total) {
    items.push(`<li class="pt-custom-shop__pagination-item pt-custom-shop__pagination-item--next">${link(current + 1, arrow, ` rel="next" aria-label="${escapeAttr(__('Next page', 'vn'))}"`)}</li>`)
  }

  return `<nav class="pt-custom-shop__pagination" aria-label="${escapeAttr(__('Products pagination', 'vn'))}"><ul class="pt-custom-shop__pagination-list">${items.join('')}</ul></nav>`
}

export { noResult, productHit, productsButton, partnerShopHit, shopPagination }
